export const FIREFLY_EVENTS = {
  EVENT_TYPE: {
    BULK_EXPORT_TEMPLATE: 'Bulk Export for Upload Template',
    BULK_UPLOAD: 'Bulk Upload',
    UPLOAD_HISTORY_GRID_ACTIONS: 'Upload History Grid Actions',
  },
  CUSTOM_INTERACTION_KEYS: {
    //1. Excel download
    PURPOSE: 'Export Purpose',
    INTENDED_USE: 'Intended Use',
    ITEM_TYPE: 'Item Type',
    EXCEL_DOWNLOAD: 'Excel Download',
    //2. Upload
    EXCEL_UPLOAD: 'Excel Upload',
    //3. Upload History
    UPLOAD_HISTORY: 'Upload History',
    DOWNLOAD_REJECTED_ITEMS: 'Download Rejected Items',
    HELPER_TEXT_CLICK: 'Helper Text Click',
  },
}
